import React, {Component} from 'react'
import './LoadingComponent.css'

export default class Loading extends Component {
    render() {
        return(
          <div>
            <h1>{'Caricamento in Corso...'}</h1>
          </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/LoadingComponent.js